import { useContext } from 'react';
import ConfirmContext from './ConfirmContext';

const useConfirm = () => {
  return useContext(ConfirmContext);
};

export default useConfirm;
